import { render } from "./PerformanceMarketingWhySection.vue?vue&type=template&id=0d199ef1"
import script from "./PerformanceMarketingWhySection.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingWhySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__